<div
  class="text-sm [&>div]:px-3"
  [ngClass]="{
    'flex flex-col': bodyObject().headerImageUrl && imageViewerUrl(),
    '-mb-5': !bodyObject().body && !bodyObject().title && !bodyObject().subTitle
  }"
  data-e2e="action-card"
>
  <!-- (Optional) Image URL - Title image. Display like a card advertisement at the top -->
  @if (bodyObject().headerImageUrl && imageViewerUrl()) {
    <img
      #actioncardimage
      [src]="imageViewerUrl"
      class="max-w-full h-auto rounded-t-2xl"
      (load)="actionCardImageLoad(actioncardimage)"
      data-e2e="action-card-image"
      alt=""
    />
  }
  <!-- (Optional) Header - Title title header. Make prominate like a card display -->
  @if (bodyObject().title) {
    <div class="mt-3 break-words text-base text-primary" data-e2e="action-card-title">
      {{ bodyObject().title }}
    </div>
  }
  <!-- (Optional) Subtitle - Make a sub-title under the header -->
  @if (bodyObject().subTitle) {
    <div
      class="break-words text-sm text-color"
      [ngClass]="{ 'mt-1': bodyObject().title, 'mt-3': !bodyObject().title }"
      data-e2e="action-card-subtitle"
    >
      {{ bodyObject().subTitle }}
    </div>
  }
  <!-- Content - Main content body -->
  <div
    class="text-color block whitespace-pre-wrap w-full break-words text-base font-semibold p-3"
    [ngClass]="{
      'p-0': bodyObject().bodyContentType === contentTypes.LOCATION,
      'pt-2':
        (bodyObject().headerImageUrl && imageViewerUrl()) ||
        (bodyObject().title && !bodyObject().subTitle) ||
        (bodyObject().title && bodyObject().subTitle && bodyObject().bodyContentType === contentTypes.LOCATION),
      'pt-1': bodyObject().title && bodyObject().subTitle && bodyObject().bodyContentType !== contentTypes.LOCATION
    }"
  >
    @switch (bodyObject().bodyContentType) {
      @case (contentTypes.HTML) {
        <span [innerHTML]="bodyObject().body | linky" data-e2e="action-card-text-content"></span>
      }
      @case (contentTypes.LOCATION) {
        <div class="p-0">
          @if (locationService.googleScriptLoaded) {
            <google-map
              height="12.5rem"
              width="18.75rem"
              [options]="{
                mapTypeControl: false,
                fullscreenControl: true,
                streetViewControl: false,
                mapId: googleMapId()
              }"
              [center]="{
                lat: latitude(),
                lng: longitude()
              }"
              [zoom]="15"
            >
              <map-advanced-marker
                #marker
                [position]="{
                  lat: latitude(),
                  lng: longitude()
                }"
              >
              </map-advanced-marker>
            </google-map>
          }
        </div>
      }
      @default {
        <span data-e2e="action-card-text-content">{{ bodyObject().body }}</span>
      }
    }
  </div>
</div>
<!-- (Optional) Action buttons -->
@if (contentType() === contentTypes.ACTIONCARD) {
  <div
    class="min-w-[75px] max-w-[360px] items-baseline border-0 border-solid border-[var(--p-surface-100)] rounded-b-2xl"
    data-e2e="action-buttons"
  >
    @for (btn of bodyObject().buttons; track $index) {
      <div
        class="text-base min-h-10 w-full text-center align-middle border-t border-solid border-[var(--p-surface-100)] first:rounded-none last:rounded-b-2xl hover:bg-[var(--p-primary-500)] [&:last-child>a]:rounded-b-2xl [&>a]:text-primary [&>a]:!no-underline [&>a]:block [&>a]:px-[13px] [&>a]:py-3 [&>a]:break-words [&:hover>a]:!text-[var(--p-surface-0)]"
        [ngClass]="{ '[&>a]:cursor-default': previewMode() }"
      >
        @switch (btn.action) {
          @case (actionCardActions.POSTMESSAGE) {
            <!-- Standard button that posts title or payload as text (to display alternate text) into the chat-->
            <a
              title="{{ btn.title || btn.payload }}"
              role="button"
              [attr.tabindex]="currentTabIndex()"
              (keydown.enter)="
                !isOffline()
                  ? sendActionMessage($event, btn.payload || btn.title, btn.behavior || btn.responseBehavior)
                  : ''
              "
              (keydown.space)="
                $event.preventDefault();
                !isOffline()
                  ? sendActionMessage($event, btn.payload || btn.title, btn.behavior || btn.responseBehavior)
                  : ''
              "
              [ngClass]="{ 'cl-chat-button-disabled': isOffline() }"
              (click)="
                !isOffline()
                  ? sendActionMessage($event, btn.payload || btn.title, btn.behavior || btn.responseBehavior)
                  : ''
              "
              data-e2e="action-button-post-message"
              >{{ btn.title || btn.payload }}</a
            >
          }
          @case (actionCardActions.POSTQUOTEDMESSAGE) {
            <!-- Standard button that posts title or payload as quote message (to display alternate text) into the chat-->
            <a
              title="{{ btn.title || btn.payload }}"
              role="button"
              [attr.tabindex]="currentTabIndex()"
              (keydown.enter)="
                !isOffline()
                  ? sendActionQuotedMessage(
                      $event,
                      btn.payload || btn.title,
                      btn.title,
                      btn.behavior || btn.responseBehavior,
                      btn.fallbackText
                    )
                  : ''
              "
              (keydown.space)="
                $event.preventDefault();
                !isOffline()
                  ? sendActionQuotedMessage(
                      $event,
                      btn.payload || btn.title,
                      btn.title,
                      btn.behavior || btn.responseBehavior,
                      btn.fallbackText
                    )
                  : ''
              "
              [ngClass]="{ 'cl-chat-button-disabled': isOffline() }"
              (click)="
                !isOffline()
                  ? sendActionQuotedMessage(
                      $event,
                      btn.payload || btn.title,
                      btn.title,
                      btn.behavior || btn.responseBehavior,
                      btn.fallbackText
                    )
                  : ''
              "
              data-e2e="action-button-post-quoted-message"
              >{{ btn.title || btn.payload }}</a
            >
          }
          <!-- Legacy support for actionCardActions.REPLY  -->
          @case (actionCardActions.REPLY) {
            <!-- Standard button that posts title or payload as quote message (to display alternate text) into the chat-->
            <a
              title="{{ btn.title || btn.payload }}"
              role="button"
              [attr.tabindex]="currentTabIndex()"
              (keydown.enter)="
                !isOffline()
                  ? sendActionQuotedMessage(
                      $event,
                      btn.payload || btn.title,
                      btn.title,
                      btn.behavior || btn.responseBehavior
                    )
                  : ''
              "
              (keydown.space)="
                $event.preventDefault();
                !isOffline()
                  ? sendActionQuotedMessage(
                      $event,
                      btn.payload || btn.title,
                      btn.title,
                      btn.behavior || btn.responseBehavior
                    )
                  : ''
              "
              [ngClass]="{ 'cl-chat-button-disabled': isOffline() }"
              (click)="
                !isOffline()
                  ? sendActionQuotedMessage(
                      $event,
                      btn.payload || btn.title,
                      btn.title,
                      btn.behavior || btn.responseBehavior
                    )
                  : ''
              "
              data-e2e="action-button-reply"
              >{{ btn.title || btn.payload }}</a
            >
          }
          @case (actionCardActions.SHARELOCATION) {
            <!-- Location action. Gets the user to share their location to the stream using location format -->
            <a
              title="{{ btn.title }}"
              role="button"
              [attr.tabindex]="currentTabIndex()"
              (keydown.enter)="
                !isOffline() ? sendLocation($event, btn.title, btn.behavior || btn.responseBehavior) : ''
              "
              (keydown.space)="
                $event.preventDefault();
                !isOffline() ? sendLocation($event, btn.title, btn.behavior || btn.responseBehavior) : ''
              "
              [ngClass]="{ 'cl-chat-button-disabled': isOffline() }"
              (click)="!isOffline() ? sendLocation($event, btn.title, btn.behavior || btn.responseBehavior) : ''"
              data-e2e="action-button-share-location"
              >{{ btn.title }}</a
            >
          }
          @case (actionCardActions.PHONE) {
            <!-- Phone action launches dialer on device. TODO: format tel: link if not specified-->
            <a
              title="{{ btn.title }}"
              role="button"
              [attr.tabindex]="currentTabIndex()"
              (keydown.enter)="
                !isOffline() ? launchDialer($event, btn.targetUrl, btn.title, btn.behavior || btn.responseBehavior) : ''
              "
              (keydown.space)="
                $event.preventDefault();
                !isOffline() ? launchDialer($event, btn.targetUrl, btn.title, btn.behavior || btn.responseBehavior) : ''
              "
              [ngClass]="{ 'cl-chat-button-disabled': isOffline() }"
              (click)="
                !isOffline() ? launchDialer($event, btn.targetUrl, btn.title, btn.behavior || btn.responseBehavior) : ''
              "
              data-e2e="action-button-phone"
              >{{ btn.title }}</a
            >
          }
          @case (actionCardActions.HTTPPOST) {
            <!-- Webhook action. POST payload to specified URL -->
            <a
              title="{{ btn.title }}"
              role="button"
              [attr.tabindex]="currentTabIndex()"
              (keydown.enter)="
                !isOffline()
                  ? postWebhookPayload(
                      $event,
                      btn.targetUrl,
                      btn.payload,
                      btn.title,
                      btn.behavior || btn.responseBehavior
                    )
                  : ''
              "
              (keydown.space)="
                $event.preventDefault();
                !isOffline()
                  ? postWebhookPayload(
                      $event,
                      btn.targetUrl,
                      btn.payload,
                      btn.title,
                      btn.behavior || btn.responseBehavior
                    )
                  : ''
              "
              [ngClass]="{ 'cl-chat-button-disabled': isOffline() }"
              (click)="
                !isOffline()
                  ? postWebhookPayload(
                      $event,
                      btn.targetUrl,
                      btn.payload,
                      btn.title,
                      btn.behavior || btn.responseBehavior
                    )
                  : ''
              "
              data-e2e="action-button-http-post"
              >{{ btn.title }}</a
            >
          }
          @case (actionCardActions.OPENLINK) {
            <!-- Link action. Launch site in new tab-->
            <a
              title="{{ btn.title }}"
              role="button"
              [attr.tabindex]="currentTabIndex()"
              (keydown.enter)="
                !isOffline() ? openLink($event, btn.targetUrl, btn.title, btn.behavior || btn.responseBehavior) : ''
              "
              (keydown.space)="
                $event.preventDefault();
                !isOffline() ? openLink($event, btn.targetUrl, btn.title, btn.behavior || btn.responseBehavior) : ''
              "
              [ngClass]="{ 'cl-chat-button-disabled': isOffline() }"
              (click)="
                !isOffline() ? openLink($event, btn.targetUrl, btn.title, btn.behavior || btn.responseBehavior) : ''
              "
              data-e2e="action-button-open-link"
              >{{ btn.title }}</a
            >
          }
          @case (actionCardActions.RAISEEVENT) {
            <!-- Raise generic event on chat component -->
            <a
              title="{{ btn.title }}"
              role="button"
              [attr.tabindex]="currentTabIndex()"
              (keydown.enter)="
                !isOffline() ? raiseEvent($event, btn.payload, btn.title, btn.behavior || btn.responseBehavior) : ''
              "
              (keydown.space)="
                $event.preventDefault();
                !isOffline() ? raiseEvent($event, btn.payload, btn.title, btn.behavior || btn.responseBehavior) : ''
              "
              [ngClass]="{ 'cl-chat-button-disabled': isOffline() }"
              (click)="
                !isOffline() ? raiseEvent($event, btn.payload, btn.title, btn.behavior || btn.responseBehavior) : ''
              "
              data-e2e="action-button-raise-event"
              >{{ btn.title }}</a
            >
          }
          @default {
            <a
              title="{{ btn.title }}"
              role="button"
              [attr.tabindex]="currentTabIndex()"
              (keydown.enter)="sendUnsupported($event, btn.title)"
              (keydown.space)="$event.preventDefault(); sendUnsupported($event, btn.title)"
              (click)="sendUnsupported($event, btn.title)"
              >{{ btn.title }}</a
            >
          }
        }
      </div>
    }
  </div>
}
